import React from "react";
import { useSelector } from 'react-redux';
import './UserDetails.scss';

import userImage from '../assets/images/user_image_placeholder.jpg';
import Spinner from "./_common/Spinner";
import UserDetailsForm from "./UserDetailsForm";

const selector = state => {
    const { language, users } = state;
    return {
        t: language.translator,
        user: users.loggedUser
    }
};

const UserDetails = () => {
    const { t, user } = useSelector(selector);

    if(Object.keys(user).length === 0 && user.constructor === Object) {
        return (
            <div className='page'>
                <Spinner size={300}/>
            </div>
        );
    } else {
        return (
            <div className='userDetails'>
                <div className='pageHeader'>
                <span className='pageHeaderTitle'>
                    {t.gettext('User')}
                    &nbsp;
                </span>
                    <span className='pageHeaderTitle pageHeaderTitle--bold'>
                    {t.gettext('Details')}
                </span>
                </div>
                <div className="pageContent">
                    <div className="userImageContainer">
                        {!userImage
                            ? <div className='userImagePlaceholder'>
                                <span className='material-icons photoIcon'>
                                    photo_camera
                                </span>
                            </div>
                            : <img src={userImage} className='userImage' alt='User avatar'/>
                        }
                        <div className="userImageAddButton">
                            <span className='material-icons userImageAddButtonIcon'>
                                add
                            </span>
                        </div>
                    </div>
                    <UserDetailsForm user={user} />
                </div>
            </div>
        );
    }
};

export default UserDetails;
